module.exports = __webpack_public_path__ + "img/arrowDown.4f4d9fbd.svg";